// Route placeholder — content rendered by global AppShell client-side.
export default function PayrollRoute() {
  return null;
}
